import Vuei18n from '@/translations';

export default [
  {
    id: 'name',
    label: Vuei18n.t('dashboard.name'),
  },
  {
    id: 'sector',
    label: Vuei18n.t('dashboard.sector'),
  },
  {
    id: 'investment',
    label: Vuei18n.t('dashboard.investment'),
  },
  {
    id: 'amount',
    label: Vuei18n.t('dashboard.amount-advertisements'),
  },
  {
    id: 'activados',
    label: 'activados',
  },
  {
    id: 'pausados',
    label: 'pausados',
  },
  {
    id: 'pendientes',
    label: 'pendientes',
  },
];
